import { render, staticRenderFns } from "./DownloadFullData.vue?vue&type=template&id=f2cae254&scoped=true"
import script from "./DownloadFullData.vue?vue&type=script&lang=ts"
export * from "./DownloadFullData.vue?vue&type=script&lang=ts"
import style0 from "./DownloadFullData.vue?vue&type=style&index=0&id=f2cae254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cae254",
  null
  
)

export default component.exports